/*!

=========================================================
* Paper Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import classnames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from 'reactstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';

function AdminNavbar(props) {
  const { isLocked } = useSelector((state) => state.application);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [color, setColor] = React.useState('navbar-transparent');
  const location = useLocation();
  const { logout, user: auth0User } = useAuth0();
  const [notificationTasks] = React.useState([]);

  const TemplateConfig = useSelector((state) => state.TemplateConfig.globalTheme);

  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      window.addEventListener('resize', updateColor);
    }
    return () => {
      isMounted = false;
    };
  });

  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (window.outerWidth < 993 && document.documentElement.className.indexOf('nav-open') !== -1) {
        document.documentElement.classList.toggle('nav-open');
      }
    }
    return () => {
      isMounted = false;
    };
  }, [location]);
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor('bg-white');
    } else {
      setColor('navbar-transparent');
    }
  };
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle('nav-open');
    setSidebarOpen(!sidebarOpen);
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  const toggleCollapse = () => {
    if (!collapseOpen) {
      setColor('bg-white');
    } else {
      setColor('navbar-transparent');
    }
    setCollapseOpen(!collapseOpen);
  };
  const getName = () => {
    if (props.loanFile && props.user) {
      let matchedNamesFromBorrowerList = props.loanFile?.[0]?.borrowers;
      if (matchedNamesFromBorrowerList && matchedNamesFromBorrowerList.length > 0) {
        const userEmail = auth0User?.email || props.user?.email || props.user?.user_metadata?.email || props.user?.app_metadata?.email;
        const matchedBorrower = matchedNamesFromBorrowerList.find(
          (b) => (b.emailAddress || '').toLowerCase() === (userEmail || '').toLowerCase()
        );
        const selectedBorrower = matchedBorrower || matchedNamesFromBorrowerList[0];
        
        return `${selectedBorrower.firstName || selectedBorrower.borrowerFirstName} ${selectedBorrower.lastName || selectedBorrower.borrowerLastName}`;
      }
    }
    return 'Guest';
  };
  return (
    <>
      <Navbar
        className={isLocked ? classnames('navbar-absolute navbar-locked fixed-top', color) : classnames('navbar-absolute fixed-top', color)}
        expand='lg'>
        <Container fluid>
          <div className='navbar-wrapper'>
            <div
              className={classnames('navbar-toggle', {
                toggled: sidebarOpen,
              })}>
              <button className='navbar-toggler' type='button' onClick={toggleSidebar}>
                <span className='navbar-toggler-bar bar1' />
                <span className='navbar-toggler-bar bar2' />
                <span className='navbar-toggler-bar bar3' />
              </button>
            </div>
            <NavbarBrand href='/' onClick={(e) => e.preventDefault()}>
              <span className='d-none d-md-block'></span>
              <span className='d-block d-md-none'></span>
            </NavbarBrand>
          </div>
          <button
            aria-controls='navigation-index'
            aria-expanded={collapseOpen}
            aria-label='Toggle navigation'
            className='navbar-toggler'
            // data-target="#navigation"
            data-toggle='collapse'
            type='button'
            onClick={toggleCollapse}>
            <span className='navbar-toggler-bar navbar-kebab' />
            <span className='navbar-toggler-bar navbar-kebab' />
            <span className='navbar-toggler-bar navbar-kebab' />
          </button>

          <Collapse className='justify-content-end' navbar isOpen={collapseOpen}>
            <Nav navbar v>
              <UncontrolledDropdown className='' nav>
                <DropdownToggle
                  aria-haspopup={true}
                  caret
                  color='default'
                  style={isLocked ? { color: '#babec5' } : {}}
                  data-toggle='dropdown'
                  id='navbarDropdownMenuLink'
                  nav>
                  <i className='nc-icon nc-bell-55 move-right' style={isLocked ? { color: '#babec5' } : {}} />
                  <p>
                    <span className='d-lg-none d-md-block'>&nbsp;&nbsp;&nbsp;Notifications</span>
                  </p>
                  <div
                    className='notification-flag'
                    style={{
                      display: notificationTasks.length > 0 ? 'block' : 'none',
                    }}></div>
                </DropdownToggle>
                <DropdownMenu persist color={isLocked ? 'red' : 'default'} aria-labelledby='navbarDropdownMenuLink'>
                  {notificationTasks.length > 0 ? (
                    notificationTasks.map((task, key) => {
                      return (
                        <Link to='/admin/tasks' key={key} className=''>
                          <DropdownItem className='btn notification-links'>You have a task that needs to be completed.</DropdownItem>
                        </Link>
                      );
                    })
                  ) : (
                    <p style={{ fontSize: '12px', margin: '5px 20px' }}>No notifications at this time.</p>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav style={{ paddingRight: '0' }}>
                <DropdownToggle aria-haspopup={true} color='default' data-toggle='dropdown' id='navbarDropdownMenuLink' nav>
                  <i className='fa-regular fa-circle-question move-left' />
                  <p>
                    <span className='d-lg-none d-md-block'>Account</span>
                  </p>
                </DropdownToggle>
                <DropdownMenu persist aria-labelledby='navbarDropdownMenuLink' right>
                  <div>
                    <p className='fontSize12 navbarInfoText'>
                      Email{' '}
                      <a className='infoContact' href={`mailto:${TemplateConfig?.adminNavbar?.emailContactLink}`}>
                        {TemplateConfig?.adminNavbar?.emailContact}
                      </a>{' '}
                      or call{' '}
                      <a className='infoContact' href={`tel:${TemplateConfig?.adminNavbar?.phoneContactLink || ''}`}>
                        {TemplateConfig?.adminNavbar?.phoneContact}
                      </a>{' '}
                      for assistance
                    </p>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown className='' nav>
                <DropdownToggle
                  style={isLocked ? { color: '#babec5' } : {}}
                  aria-haspopup={true}
                  caret
                  color='default'
                  data-toggle='dropdown'
                  id='navbarDropdownMenuLink'
                  nav>
                  {props.loanFile && (
                    <>
                      <i className='fa-regular fa-circle-user move-left' style={isLocked ? { color: '#babec5' } : {}} />
                      <p>
                        <span className=' d-md-block' style={isLocked ? { color: '#babec5' } : {}}>
                          {getName()}
                        </span>
                      </p>
                    </>
                  )}
                </DropdownToggle>
                <DropdownMenu persist aria-labelledby='navbarDropdownMenuLink' right>
                  <DropdownItem
                    className='move-right btn notification-link'
                    onClick={() => {
                      localStorage.removeItem('selectedLoan');
                      localStorage.removeItem('hasVisitedSplashPage');
                      logout({
                        returnTo: `${window.location.origin}${process.env.REACT_APP_HOMEPAGE_PATH}`,
                      });
                    }}>
                    <>
                      <i className='fas fa-power-off move-left' />
                      <span>Log out</span>
                    </>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
